import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";
import { ToastContainer } from "react-toastify";
import Table from "../../components/Table";

export default function CustomerApplications({ lang = {} }) {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = () => {
    const session = JSON.parse(sessionStorage.getItem("aman-customer") || "{}");
    const token = session.token;
    if (!token) return;

    axios
      .get(`${apiKey}/customer-panel/applications`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setApplications(res.data.applications || []);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
    },
    // {
    //   header: lang["App ID"] || "App ID",
    //   accessorKey: "id",
    //   cell: (row) => <span className="fw-bold text-primary">#{row.getValue()}</span>,
    // },
    {
      header: lang["Target_Branch"] || "Target Branch",
      accessorKey: "branch_name",
      cell: (row) => (
        <div>
          <strong className="text-dark">{row.getValue() || "Branch"}</strong>
          {row.row.original.branch_location && (
            <>
              <br />
              <span className="small text-muted">{row.row.original.branch_location}</span>
            </>
          )}
        </div>
      ),
    },
    {
      header: lang["Contract_Type"] || "Contract Type",
      accessorKey: "contract_type",
      cell: (row) =>
        row.getValue() === "future" ? "Future (آجل)" : "Installment (تقسيط)",
    },
    {
      header: lang["Amount"] || "Amount",
      accessorKey: "total_amount",
      cell: (row) => (
        <span className="fw-bold text-primary">
          SAR {Number(row.getValue() || 0).toLocaleString()}
        </span>
      ),
    },
    {
      header: lang["Term"] || "Term",
      accessorKey: "months",
      cell: (row) =>
        row.row.original.contract_type === "future"
          ? "1 Single Payment"
          : `${row.getValue() || row.row.original.no_of_installments || 12} Months`,
    },
    {
      header: lang["Status"] || "Status",
      accessorKey: "status",
      cell: (row) => {
        const status = row.getValue();
        return status === "approved" ? (
          <span className="badge rounded-pill bg-success">{lang.approved || "Approved"}</span>
        ) : status === "rejected" ? (
          <span className="badge rounded-pill bg-danger">{lang.rejected || "Rejected"}</span>
        ) : (
          <span className="badge rounded-pill bg-warning text-dark">{lang.pending || "Pending Review"}</span>
        );
      },
    },
    {
      header: lang["Details_Reason"] || "Details / Reason",
      cell: (row) => {
        const status = row.row.original.status;
        return status === "rejected" ? (
          <span className="text-danger fw-bold">
            Reason: {row.row.original.rejection_reason || "Not specified"}
          </span>
        ) : status === "approved" ? (
          <span className="text-success fw-bold">Accepted by Branch</span>
        ) : (
          <span className="text-muted">Under Review</span>
        );
      },
    },
  ];

  return (
    <div className="container-fluid px-4 py-3">
      <ToastContainer />
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Application_Status || "Application Status"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang.Home || "Home"}</li>
            <li className="breadcrumb-item active">{lang.Application_Status || "Application Status"}</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">
                  {lang.Submitted_Applications || "Submitted Contract Applications"}
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <Table
                    columns={columns}
                    data={applications}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
